import { t } from "@bookingcom/lingojs-core";
import React from "react";
import { Actionable, Icon, Text } from "@bookingcom/bui-react";
import { CrossIcon } from "@bookingcom/bui-assets-react/streamline";
import styles from "./Tags.module.css";
const renderLocationLabel = (loc, i18n) => {
    switch (loc.type) {
        case "CITY":
            return (React.createElement(React.Fragment, null,
                React.createElement("b", null, loc.name),
                ` ${i18n.trans(t("flights_multi_select_all_airports"))}`));
        case "COUNTRY":
            return React.createElement("b", null, loc.name);
        default:
            return (React.createElement(React.Fragment, null,
                React.createElement("b", null, loc.code),
                ` ${loc.cityName || loc.name}`));
    }
};
const getLocationText = (loc, i18n) => {
    switch (loc.type) {
        case "CITY":
            return `${loc.name} ${i18n.trans(t("flights_multi_select_all_airports"))}`;
        case "COUNTRY":
            return loc.name;
        default:
            return `${loc.code} ${loc.cityName || loc.name}`;
    }
};
export default function Tags(props) {
    const { selectedLocations, i18n, onClick } = props;
    return (React.createElement(React.Fragment, null, selectedLocations.map((loc, idx) => (React.createElement(Actionable, { key: loc.code + loc.type + idx, className: styles.item, attributes: {
            "aria-label": `${getLocationText(loc, i18n)}, ${i18n.trans(t("a11y_flights_airport_city_chip_remove"))}`
        }, onClick: () => onClick(idx) },
        React.createElement(Text, { tagName: "span", variant: "body_2", className: styles.text }, renderLocationLabel(loc, i18n)),
        React.createElement(Icon, { size: "small", className: styles.icon, svg: CrossIcon }))))));
}
